export const tooltipContainerStyles = {
  backgroundColor: "var(--semantic-color-background-primary)",
  boxShadow: "var(--box-shadow-30)",
  padding: "1.6rem",
  border: "0.1rem solid var(--color-default-outline)",
  borderRadius: "0.8rem",
};
